import dayjs from 'dayjs';
import React from 'react';
import * as Utility from '../../../core/utility';
import { DummyCampaignImage } from '../../../config/config';
import storyIcon from '../../../assets/images/story.svg';
import reelsIcon from '../../../assets/images/reels.svg';
import digitalRightsIcon from '../../../assets/images/digital-rights.svg';
import shortsIcon from '../../../assets/images/shorts.png';
import dedicatedIcon from '../../../assets/images/dedicated-video.png';
import integratedIcon from '../../../assets/images/integrated-video.svg';
import exclusivityIcon from '../../../assets/images/exclusivity-black.svg';
import staticIcon from '../../../assets/images/static.svg';
import { Skeleton } from '@mui/material';
import InstagramIcon from '../../../components/icons/instagram-icon';
import YouTubeIcon from '@mui/icons-material/YouTube';

interface Props {
  data:any;
  loading:Boolean;
  onClick:any;
  isMobile:any;
  campaign_id:any;
  sm_id?:any;

}
const methods: Utility.Methods = new Utility.Methods();
const deliverableIcons: any = {
  story: storyIcon,
  reels: reelsIcon,
  'digital rights': digitalRightsIcon,
  shorts: shortsIcon,
  static: staticIcon,
  'dedicated video': dedicatedIcon,
  'integrated video': integratedIcon,
  'exclusivity': exclusivityIcon
};
const CampaignCardMobile = ({ data, loading, onClick }:Props) => {
  console.log('data', data);
  return (
    <div className="mobile-card" onClick={() => onClick(data)}>
      <div className="mobile-card-header">
        {/* IMAGE */}
        <div className="mobile-card-image">
          
          <img
            src={data.campaign_cover_url || DummyCampaignImage.default_campaign_image}
            alt=""
          />
        </div>
      
        {/* CONTENT */}
        <div className="mobile-card-content">
          {loading ? <Skeleton animation="wave" /> :
            <div className='badge-sec self-start'>
              <span className='badge badge-primary-outline  btn-sm'>
                {(
                data
                    ?.campaign_platform + ''
                ).toLocaleLowerCase() === 'instagram' ? (
                <InstagramIcon width="16px" height="16px" />
                ) : (
                <YouTubeIcon sx={{ width: 20, height: 20 }} />
                )}{data?.campaign_type}
              </span>
              {data?.proposal_ids && (
                <span className='btn btn-primary btn-sm'>Applied</span>
              )}
            </div> 
          }
          {/* TITLE */}
          <h3>{data.campaign_title}</h3>

          {/* POSTED */}
          <p className="posted">
            Posted {methods.calculateDaysDifference(new Date(data.posted_at), new Date())} days ago
          </p>
  <div className="chips d-none d-sm-flex mt-2">
              {data.deliverables?.split(',').map((d: string) => {
                  const label = d.trim();
                  const key = label.toLowerCase();

                  return (
                  <span key={d} className="chip">
                      {deliverableIcons[key] && (
                      <img src={deliverableIcons[key]} alt={label} />
                      )}
                      <span className='chip-text'>{label}</span>
                  </span>
                  );
              })}
          </div>
          {/* CHIPS */}
          {/* <div className="chips">
            {data.deliverables?.split(',').map((d:string) => (
              <span key={d}>{d.trim()}</span>
            ))}
          </div> */}
          

          
        </div>
      </div>
      <div className="chips d-sm-none">
              {/* {data.deliverables?.split(',').map((d: string) => {
                  const label = d.trim();
                  const key = label.toLowerCase();

                  return (
                  <span key={d} className="chip">
                      {deliverableIcons[key] && (
                      <img src={deliverableIcons[key]} alt={label} />
                      )}
                      <span className='chip-text'>{label}</span>
                  </span>
                  );
              })} */}
              {data.deliverables?.split(',').map((d: string) => {
                const label = d.trim();
                const key = label.toLowerCase();

                return (
                  <span key={d} className="chip">
                    {deliverableIcons[key] && (
                      <img
                        src={deliverableIcons[key]}
                        alt={label}
                        className={`deliverable-icon icon-${key.replace(/\s+/g, '-')}`}
                      />
                    )}
                    <span className="chip-text">{label}</span>
                  </span>
                );
              })}
          </div>
      {/* META */}
        <div className="meta">
          <span>Gender  <strong>{data.influencer_gender}</strong></span>
          <span>Deadline <strong>{dayjs(data.proposal_dt).format('LL')}</strong></span>
        </div>

        {/* CLOSED */}
        {data.days_old >= 1 && (
          <span className="closed">Application Closed</span>
        )}
    </div>
  );
};

export default CampaignCardMobile